import React, { FunctionComponent, ReactElement, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
  clearPdf,
  requestEventPdf,
} from '../../../../actions/events/fetchEventPdf'
import {
  BB_RESERVATION_PDF_EXPORT,
  BB_RESERVATION_PDF_EXPORT_SCOPE,
  RESERVATION_PDF_EXPORT_VERSION,
} from '../../../../constants/webViewPdfExport'
import { IEvent } from '../../../../models/Event'
import { postWebViewHostPayload } from '../../../../utils/reactNativeWebView'
import { getUpdateReservationFormEvent } from '../../../../reducers/bookingCalendar/selectors/events'
import {
  getEventPdf,
  getEventPdfId,
  getRequestStatus,
} from '../../../../reducers/events/selectors/pdf'

export interface IExportReservationProps {
  pdf: string
  isLoading: boolean
  loadPdf: (eventId: IEvent['id']) => void
  clearPdf: () => void
  loadingElement: ReactElement
  event: IEvent
  eventId?: string
  full?: boolean
  onClick: () => void
}

const ExportReservation: FunctionComponent<IExportReservationProps> = ({
  pdf,
  isLoading,
  event,
  loadPdf,
  clearPdf,
  eventId,
  loadingElement,
  children,
  full = false,
  onClick = undefined,
}) => {
  const [t, i18n] = useTranslation()
  const ref: React.RefObject<HTMLDivElement> = React.useRef()

  useEffect(() => {
    if (!isLoading && pdf && eventId === event.id) {
      const linkSource = `data:application/pdf;base64,${pdf}`
      const downloadLink = document.createElement('a')
      const fileName = `${t('title_activity_reservation')} - ${event.id}.pdf`

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.style.display = 'none'
      ref.current.parentNode.insertBefore(downloadLink, ref.current)
      downloadLink.click()
      clearPdf()
    }
  })

  const onExportClick = () => {
    if (onClick) {
      onClick()
    }
    if (
      postWebViewHostPayload({
        fileName: `${t('title_activity_reservation')} - ${event.id}.pdf`,
        lang: i18n.language,
        reservationId: String(event.id),
        scope: BB_RESERVATION_PDF_EXPORT_SCOPE,
        type: BB_RESERVATION_PDF_EXPORT,
        version: RESERVATION_PDF_EXPORT_VERSION,
      })
    ) {
      return
    }
    loadPdf(event.id)
  }

  return (
    <div
      ref={ref}
      onClickCapture={onExportClick}
      style={{ width: full ? '100%' : '' }}
    >
      {(!isLoading || eventId !== event.id) && children}
      {isLoading && event.id === eventId && loadingElement}
    </div>
  )
}

const mapStateToProps = () => {
  return (state, ownProps) => ({
    event: ownProps.event
      ? ownProps.event
      : getUpdateReservationFormEvent(state),
    eventId: getEventPdfId(state),
    pdf: getEventPdf(state),
    ...getRequestStatus(state),
  })
}

const bindDispatchToProps = (dispatch: Dispatch) => ({
  clearPdf: () => dispatch(clearPdf()),
  loadPdf: (eventId: IEvent['id']) => dispatch(requestEventPdf(eventId)),
})

export default connect(
  mapStateToProps(),
  bindDispatchToProps,
)(ExportReservation)
